import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  body: {
    top: 0,
    height: "100vh",
    color: theme.design.color.text.primary,
    zIndex: theme.design.layer.sticky,

    "& .MuiPaper-root": {
      backgroundColor: theme.design.color.surface.canvas,
      color: theme.design.color.text.primary,
    },

    "& .MuiAccordionDetails-root": {
      maxHeight: "calc(100vh - 394px)",
      overflowY: "auto",
    },
  },
  container: {
    width: 450,
    padding: "80px 16px 12px 16px",
    display: "flex",
    flexDirection: "column",
    fontFamily: theme.design.typography.fontFamily,
    height: "100%",
    boxSizing: "border-box",
    position: "relative",

    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },

  expandIcon: {
    height: "40px",
    minHeight: "40px",
    display: "flex",
    alignItems: "center",
    position: "absolute",
    top: "16px",

    "& button": {
      width: 24,

      minWidth: 12,

      "& svg": {
        color: theme.design.color.text.primary,
        cursor: "pointer",
        transition: "0.3s",
        fontSize: "20px",
        "&:hover": {
          color: theme.design.color.text.secondary,
          transition: "0.3s",
        },
      },
    },
  },

  header: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    padding: "0 10px",
    alignItems: "center",
    position: "relative",
    minHeight: "100px",
  },

  subHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.design.space.lg,
    fontSize: "20px",
    cursor: "pointer",
  },

  messengerImg: {
    width: "30px",
  },

  disabledText: {
    color: theme.design.color.surface.control,
  },

  divider: {
    backgroundColor: theme.design.color.border.popover,
    height: "50%",
    position: "absolute",
    left: "50%",
  },

  dividerHorizontal: {
    backgroundColor: theme.design.color.border.popover,
    width: "80%",
  },

  dividerHorizontalBox: {
    display: "flex",
    justifyContent: "center",
  },

  chatBody: {
    flex: 1,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",

    position: "relative",
  },

  selectFamilyBox: {
    display: "flex",
    justifyContent: "center",
    marginTop: "12px",
    position: "relative",
  },

  selectFamily: {
    backgroundColor: theme.design.color.surface.raised,
    width: "80%",
    position: "absolute",

    "& .MuiAccordionSummary-content": {
      display: "flex",
      justifyContent: "center",
    },

    "& .MuiSvgIcon-root, & svg": {
      color: theme.design.color.text.primary,
    },

    "& .MuiCollapse-root": {
      backgroundColor: theme.design.color.surface.raised,
      borderRadius: `0 0 ${theme.design.radius.lg}px ${theme.design.radius.lg}px`,
    },

    "& .MuiAccordionDetails-root": {
      padding: "0",
    },
  },

  dropdownValue: {
    backgroundColor: theme.design.color.surface.raised,
    display: "flex",
    justifyContent: "center",
    borderRadius: `${theme.design.radius.lg}px ${theme.design.radius.lg}px 0 0`,
  },

  fullBorderR: {
    borderRadius: theme.design.radius.lg,
  },

  detailsBody: {
    display: "flex",
    flexDirection: "column",
  },

  selectDetail: {
    display: "grid",
    gridTemplateColumns: "1fr 5fr 1fr",
    minHeight: "50px",
    alignItems: "center",
    transition: "0.3s",
    cursor: "pointer",

    "&>div": {
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },

    "&>div:nth-of-type(3)": {
      color: theme.design.color.text.secondary,
    },

    "& img": {
      width: "20px",
    },

    "&:hover": {
      backgroundColor: theme.design.color.surface.interactive,
      transition: "0.3s",
    },
  },

  valueBox: {
    display: "grid",
    gridTemplateColumns: "1fr 5fr 1fr",
    alignItems: "center",
    transition: "0.3s",
    width: "100%",

    "&>div": {
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },

    "&>div:nth-of-type(3)": {
      color: theme.design.color.text.secondary,
    },

    "& img": {
      width: "20px",
    },
  },

  chatBodyContainer: {
    overflowY: "auto",
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column-reverse",
    justifyContent: "end",

    "&>div:not(:last-of-type)": {
      borderTop: `1px solid ${theme.design.color.border.default}`,
    },
  },

  containerLoading: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    width: "100%",

    "& svg": {
      color: theme.design.color.text.secondary,
    },
  },

  containerFamily: {
    marginTop: 60,
    maxHeight: "calc(100vh - 330px)",
  },

  containerMain: {
    maxHeight: "calc(100vh - 250px)",
  },

  chatList: {
    padding: "16px 0",
  },

  role: {
    fontSize: "16px",
    fontWeight: 900,
  },

  logoImg: {
    width: "18px",
    marginTop: "3px",
    verticalAlign: "sub",
  },

  name: {
    fontSize: "16px",
    color: theme.design.color.text.link,
    fontWeight: 900,
    "&>a": {
      color: theme.design.color.text.link,
      textDecoration: "none",
    },
  },

  chatText: {
    color: theme.design.color.text.muted,
    fontSize: "14px",
  },

  inputBox: {
    width: "100%",
    display: "flex",
    gap: theme.design.space.lg,
    minHeight: "60px",
    alignItems: "center",
  },

  chatInput: {
    flex: 1,
    color: theme.design.color.text.primary,
    backgroundColor: theme.design.color.surface.control,
    borderRadius: theme.design.radius.md,
    minHeight: "40px",
    "& fieldset": {
      outline: "none",
      border: "none",
      minHeight: "40px",
    },
    "& .MuiInputBase-input": {
      color: theme.design.color.text.primary,
      padding: "12px 14px",
      height: 20,

      "&:disabled": {
        opacity: 1,
        WebkitTextFillColor: theme.design.color.text.secondary,
      },
    },
  },

  sendBut: {
    textTransform: "none",
    color: theme.design.color.text.primary,
    fontSize: "16px",
    lineHeight: "32px",
    backgroundColor: theme.design.color.surface.control,
    minWidth: "100px",
    borderRadius: theme.design.radius.md,
  },

  emojiIcon: {
    width: "20px",
    cursor: "pointer",
  },
}));
